<template>
  <div>
    <vx-card class="w-full">
      <vs-row class="mb-6">
        <vs-col class="flex flex-col xl:flex-row gap-y-5" vs-justify="flex-end">
          <div class="mr-auto" style="display: grid; align-items: center">
            <slot name="header" :board="board" :isPrint="isPrint" />
          </div>

          <div class="w-full xl:w-auto grid grid-cols-2 xl:flex gap-2 xl:gap-4 ml-auto">
            <vs-button v-if="isUpdateMode && usePrint" color="secondary" @click="onClickPrint" class="hidden xl:block">{{ printLabel }}</vs-button>
            <vs-button v-if="(useDelete && isUpdateMode && created && !board.readonly && permission && permission.d) || isAdmin" color="secondary" type="border" @click="onClickRemove">삭제</vs-button>
            <vs-button color="secondary" type="border" @click="onClickMoveList">목록</vs-button>
            <vs-button v-if="isSaveAvailable()" color="secondary" @click="onClickSave">저장</vs-button>
          </div>
        </vs-col>
      </vs-row>

      <vs-row>
        <vs-col>
          <div id="print-report">
            <slot name="body" :board="board" :isPrint="isPrint" />
          </div>
        </vs-col>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
export default {
  name: "NormalDocument",
  components: {},
  props: {
    docProjectId: String | Number,
    usePrint: {
      type: Boolean,
      default: true,
    },
    usePrintTitle: {
      type: Boolean,
      default: true,
    },
    printLabel: {
      type: String,
      default: () => "인쇄",
    },
    useDelete: {
      type: Boolean,
      default: true,
    },
    created: {
      type: Boolean,
      default: true,
    },
    tab: Object,
    permission: Object | undefined,
  },
  computed: {
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
    boardInfo() {
      return this.$store.state.board.postInfo;
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },

    isUpdateMode() {
      return this.$route.params.postId;
    },
    getClasses() {
      if (this.toggleSide) {
        return "fix-grid";
      }
      return "hide-grid";
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
  },
  watch: {
    projectInfo(value) {
      if (value) {
        this.board.projectTitle = value.field_name;
      }
    },

    boardInfo(boardInfo) {
      // 권한체크
      this.checkPermission();
    },

    permission(value) {
      // 권한체크
      this.checkPermission();
    },

    board: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("board", value);
      },
    },
  },
  data() {
    return {
      isPrint: false,
      // TODO : 글쓰기 정보 및 권한
      board: {
        projectTitle: this.$store.state.project.projectInfo.field_name,
        writer: {}, //작성자 정보
        readonly: false, // 읽기전용인가
        isPrint: false,
        viewSaveBtn: true,
      },
    };
  },
  async mounted() {
    await this.init();
  },

  methods: {
    async init() {
      await this.$store.dispatch("USER_INFO");
      this.board.writer = {
        id: this.$store.state.auth.userInfo.id,
        name: this.$store.state.auth.userInfo.name,
        company_id: this.$store.state.auth.userInfo.company_id,
        department: this.$store.state.auth.userInfo.department,
        section: this.$store.state.auth.userInfo.section,
        rank: this.$store.state.auth.userInfo.rank,
        com_name: "",
      };

      await this.$store.dispatch("company/LOAD_COMPANY", {
        companyId: this.board.writer.company_id,
      });
      this.board.writer.com_name = this.$store.state.company.companyInfo.com_name;
      if (!this.board.writer.section) {
        this.board.writer.section = this.board.writer.com_name;
      }

      // 권한체크
      await this.checkPermission();
    },

    async checkPermission() {
      this.board.readonly = false;
      if (this.$store.state.board.postInfo.author) {
        this.board.author = {
          id: this.$store.state.board.postInfo.author.id,
          name: this.$store.state.board.postInfo.author.name,
          company_id: this.$store.state.board.postInfo.author.company_id,
          department: this.$store.state.board.postInfo.author.department,
          section: this.$store.state.board.postInfo.author.section,
          rank: this.$store.state.board.postInfo.author.rank,
          com_name: "",
        };
        await this.$store.dispatch("company/LOAD_COMPANY", {
          companyId: this.$store.state.board.postInfo.author.company_id,
        });
        this.board.author.com_name = this.$store.state.company.companyInfo.com_name;
        if (!this.board.author.section) {
          this.board.author.section = this.board.author.com_name;
        }

        // 글 작성자와 접속자의 정보가 다를 경우, 읽기 전용으로
        if (this.postId && this.board.author.id !== this.board.writer.id) {
          // 저장 버튼도 표시할 수 없는 상태일 경우, 읽기 전용으로 바꾼다
          if (!this.isSaveAvailable()) {
            this.board.readonly = true;
          }
        } else if (this.tab.byCurrentLocation) {
          // 다른 프로젝트에서 불러왔을 경우에는 읽기전용으로
          if (this.projectId !== this.docProjectId) {
            this.board.readonly = true;
          }
        }
      }

      // 작성권한이 없을 경우 읽기전용으로 변경
      // 수정권한이 없을 경우 읽기전용으로 변경
      // checkPermission() 메서드에서 처리하고 있으므로, 여기서는
      if (!this.permission.c || !this.permission.u) {
        this.board.readonly = true;
      }

      if (this.isAdmin) {
        this.board.readonly = false;
      }
    },

    isSaveAvailable() {
      // 시스템 관리자면 수정 가능
      if (this.isAdmin) return true

      // 작성 기능이 꺼져있으면 수정 불가
      if (!this.created || !this.board.viewSaveBtn) return false

      // 게시판 권한을 갖고있는지 확인한다.
      // 수정 중일 경우
      if (this.isUpdateMode) {
        if (!this.permission) return false

        // 만약 모든 사용자가 수정 가능하도록 설정되어 있는지 확인
        if (this.$store.state.board.boardData.editable_by_every_user) {
          return true;
        }

        // 만약 상위 업체에서 수정 가능하도록 설정되어있으면 업체 관계를 확인한다.
        if (this.$store.state.board.boardData.editable_by_parent_company) {
          const editableCompanyIds = this.$store.state.board.postInfo.editable_company_ids;
          const myCompanyId = this.$store.state.auth.companyInfo.id;

          if (editableCompanyIds && editableCompanyIds.length > 0) {
            const editable = editableCompanyIds.includes(myCompanyId);
            if (editable) {
              return true;
            }
          }
        }

        // 만약 같은 업체에서 수정이 가능하도록 되어 있을 경우에도 확인한다
        if (this.$store.state.board.boardData.editable_by_company_member && this.boardInfo.author) {
          const authorCompanyId = this.boardInfo.author.company_id ? this.boardInfo.author.company_id : 0;
          const myCompanyId = this.$store.state.auth.companyInfo.id;

          const editable = `${authorCompanyId}` === `${myCompanyId}`;
          if (editable) {
            return true;
          }
        }
        return !!this.permission.u;
      } else {
        // 생성 중일 경우
        return !!this.permission.c;
      }
    },

    async onClickSave() {
      this.$emit("save");
    },

    onClickMoveList() {
      this.$emit("move", "list");
    },
    printLandscape() {
      this.print("@media print {@page { size: a3 landscape; }}");
    },
    printPortrait() {
      this.print("@media print {@page { size: a3 portrait; }}");
    },
    print(css) {
      // 프린트
      this.isPrint = true;
      this.board.isPrint = true;

      if (this.tab) {
        document.getElementById("hidePrintTitle").value = this.tab.hidePrintTitle ? "true" : "false";
      }
      document.getElementById("isPrint").value = "true";

      setTimeout(() => {
        const printTextarea = document.getElementsByClassName("print-textarea");
        for (let i = 0; i < printTextarea.length; i++) {
          const pt_r = printTextarea[i].innerHTML.trimStart().trimEnd().replace(/\r\n/gi, "<br>").replace(/\\n/gi, "<br>").replace(/\n/gi, "<br>");

          document.getElementsByClassName("print-textarea")[i].innerHTML = pt_r;
        }
        const isPrint = document.getElementById("isPrint").value === "true";
        const hidePrintTitle = document.getElementById("hidePrintTitle").value === "true";

        const g_label = document.getElementById("print-label") ? document.getElementById("print-label").innerHTML : "";
        const g_oBeforeBody = document.getElementById("print-report").innerHTML;

        // 프린트를 보이는 그대로 나오기위한 셋팅
        window.onbeforeprint = function () {
          document.body.style.backgroundColor = "#fff";
          document.body.innerHTML = "";
          if (g_label && isPrint && !hidePrintTitle) {
            document.body.innerHTML += `${g_label}<br>`;
          }
          document.body.innerHTML += g_oBeforeBody;
        };

        const head = document.head || document.getElementsByTagName("head")[0],
          style = document.createElement("style");

        style.type = "text/css";
        style.media = "print";

        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }

        head.appendChild(style);

        window.print();
        location.reload();
      }, 300);
    },
    onClickPrint() {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "레이아웃 선택",
          messageIcon: "AlertCircleIcon",
          message: "인쇄 방향을 선택해 주세요.",
          useConfirm: true,
          confirmBtn: "세로 방향",
          cancelBtn: "가로 방향",
          confirmFunction: () => this.printPortrait(),
          cancelFunction: () => this.printLandscape(),
          size: "small",
          btnPosition: "center",
          confirmBtnStyle: {
            type: "border",
            icon: { type: "image", name: "icon-print-layout-vertical.svg" },
            style: "",
          },
          cancelBtnStyle: {
            type: "border",
            icon: { type: "image", name: "icon-print-layout-horizontal.svg" },
            style: "",
          },
        },
      });
      window.dispatchEvent(customAlert);
    },
    onClickRemove() {
      // 수정중
      if (this.isUpdateMode) {
        if (confirm("정말 삭제하시겠습니까?")) {
          this.$emit("remove");
        }
      }
      // 작성중
      else {
        this.$emit("move", "list");
      }
    },
    saveButtonControl(value) {
      this.board.viewSaveBtn = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.fix-grid {
  display: grid !important;
  grid-template-columns: 9fr 3fr;
}

.hide-grid {
  display: grid !important;
  grid-template-columns: 9fr 0px;
}

.toggle-btn {
  padding: 0.5rem !important;
  height: 100%;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  background-color: lightgray;
  color: #fff;
}
</style>
<style>
.con-vs-tabs .con-slot-tabs {
  overflow: initial;
}
</style>
